module.exports = __webpack_public_path__ + "assets/img/kv-96065ec7.jpg";